import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    pageWrapper: {
        background: 'var(--brand-bg, #fff)',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 32px',
        height: 64,
        borderBottom: '1px solid var(--brand-border, #F0F0F0)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        flexShrink: 0,
        background: 'var(--brand-bg, #fff)',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 3,
            background: 'linear-gradient(90deg, #FF6900 0%, #FF9A00 100%)',
        },
    },
    logo: {
        height: 44,
    },
    headerCenter: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pointerEvents: 'none',
    },
    headerRight: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
    },
    mainRow: {
        display: 'flex',
        flex: 1,
        overflow: 'hidden',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    panelColumn: {
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    chatPanel: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
    },
    chatScroll: {
        flex: 1,
        overflowY: 'auto',
        padding: '16px 20px',
    },
    botBubbleWrap: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: 12,
    },
    userBubbleWrap: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: 12,
    },
    botBubble: {
        background: 'var(--brand-surface, #f0f4f8)',
        color: 'var(--brand-text, #222)',
        padding: '10px 14px',
        borderRadius: '12px 12px 12px 4px',
        maxWidth: '95%',
        fontSize: 14,
        lineHeight: 1.5,
    },
    userBubble: {
        background: 'linear-gradient(135deg, #0097B2 0%, #3cc6f3 100%)',
        color: '#fff',
        padding: '10px 14px',
        borderRadius: '12px 12px 4px 12px',
        maxWidth: '90%',
        fontSize: 14,
    },
    thankYouBox: {
        marginTop: 16,
        padding: 16,
        background: 'var(--brand-surface, #f0faf0)',
        borderRadius: 8,
        border: '1px solid var(--brand-border, #c8e6c9)',
    },
    agentLabel: {
        padding: '12px 20px 0',
        fontSize: 13,
        fontWeight: 600,
        color: '#0097B2',
    },

    // ── Chip / pill selector (matches DQ Pro schedule picker) ────────────────
    chipFormWrap: {
        marginTop: 16,
        padding: 16,
        background: 'var(--brand-surface, #fff)',
        borderRadius: 12,
        border: '1px solid var(--brand-border, #f0e3d6)',
    },
    chipFormTitle: {
        fontSize: 15,
        fontWeight: 700,
        color: 'var(--brand-text, #1a1a1a)',
        lineHeight: 1.4,
        marginBottom: 2,
    },
    chipFormSubtitle: {
        fontSize: 13,
        color: '#888',
        lineHeight: 1.4,
        marginBottom: 10,
    },
    chipsColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        width: '100%',
    },
    chip: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        backgroundColor: 'var(--brand-surface, #fff)',
        color: 'var(--brand-text, #1a1a1a)',
        border: '1px solid #FF6900',
        borderRadius: 999,
        padding: '11px 16px',
        fontSize: 14,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        boxSizing: 'border-box',
        textAlign: 'center',
        '&:hover': {
            backgroundColor: '#FFF3E9',
        },
    },
    chipSelected: {
        backgroundColor: '#FF6900',
        color: '#fff',
        border: '1.5px solid #FF6900',
        '&:hover': {
            backgroundColor: '#FF6900',
        },
    },
    chipOwn: {
        backgroundColor: 'var(--brand-surface, #F3F4F6)',
        color: 'var(--brand-text-muted, #555)',
        border: '1.5px solid #D1D5DB',
        '&:hover': {
            backgroundColor: '#E5E7EB',
            color: '#111',
            border: '1.5px solid #9CA3AF',
        },
    },
    chipDisabled: {
        opacity: 0.45,
        cursor: 'default',
        pointerEvents: 'none',
    },
    chipOtherInput: {
        marginTop: 8,
    },
    chipContinueWrap: {
        marginTop: 20,
        width: '100%',
    },
    chipContinueBtn: {
        textTransform: 'none',
        backgroundColor: '#FF6900',
        color: '#fff',
        '&:hover': { backgroundColor: '#E65C00' },
        '&.Mui-disabled': { backgroundColor: '#f0c3a3', color: '#fff' },
    },
    chipErrorText: {
        display: 'block',
        marginTop: 8,
        color: '#d32f2f',
    },
}));

export default useStyles;
